import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type SubmitGiftVoucherFiservPaymentMutation,
    type SubmitGiftVoucherFiservPaymentMutationVariables,
    SubmitGiftVoucherFiservPaymentDocument,
} from '../../../../../api/mutations/submitGiftVoucherFiservPayment';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';

// calls fiserv submit payment api
// this calls the manage transactions of porsche
export const submitPayment = async (agreements: AgreementValues, token: string, promoCodeId?: string) => {
    const response = await fetch('/api/fiserv/submitGiftVoucherPayment', {
        method: 'POST',
        body: JSON.stringify({
            token,
            agreedConsents: Object.entries(agreements)
                .filter(Boolean)
                .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null)),
            promoCodeId,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error();
    }

    return response.json();
};

// fiserv deposit submission calls the application journey
const useGiftVoucherFiservDepositSubmission = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: AgreementValues, skipDeposit: boolean) => {
            const { data } = await apolloClient.mutate<
                SubmitGiftVoucherFiservPaymentMutation,
                SubmitGiftVoucherFiservPaymentMutationVariables
            >({
                mutation: SubmitGiftVoucherFiservPaymentDocument,
                variables: {
                    token,
                    agreedConsents: Object.entries(values)
                        .filter(Boolean)
                        .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                        .filter(Boolean),
                    skipDeposit,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useGiftVoucherFiservDepositSubmission;
